import Loading from "components/loading/loading.component";
import PriceTable from "components/price/price.component";
import { IChoosePlan } from "interfaces/RegisterInterface";
import { ISubscription } from "interfaces/subscription.interface";
import React from "react";
import { useNavigate } from "react-router-dom";

const ChoosePlan: React.FC<IChoosePlan> = ({
  status,
  onPlanSelect,
  subscriptionList,
  activeTab,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="topic">
        <h2 className="text-display-lg text-white text-center">
          Let’s start learning
        </h2>
        <p className="mt-4 text-base font-normal leading-4 text-white text-center">
          Confirm your plan below
        </p>
      </div>
      <div className="flex justify-center mt-5">
        {status === "pending" ? (
          <Loading />
        ) : status === "error" ? (
          <h1>Package Loading Failed. Please refresh the page</h1>
        ) : (
          <PriceTable
            items={subscriptionList || []}
            onSubscriptionSelect={(item: ISubscription, index: number) =>
              onPlanSelect(item, index)
            }
          />
        )}
      </div>
      <div className="flex justify-center mt-5">
        <p className="text-sm font-normal text-white">
          {activeTab === 0 ? (
            <span className="text-white">Already have a membership?</span>
          ) : (
            <span>Already have a subscription? </span>
          )}
          <span
            className="pl-1 font-bold underline cursor-pointer text-white underline-offset-2"
            onClick={() => navigate("/login")}
          >
            Login
          </span>
        </p>
      </div>
    </>
  );
};

export default ChoosePlan;
